<template>
  <div class="downloadh5" ref="downloadh5">
    <div class="introduce">
      <div class="video-box">
        <video
          src="@/assets/xiazai.mp4"
          :controls="false"
          alt=""
          ref="video"
          class="video"
        />
      </div>
      <div class="text">
        <div class="t1">管理全面升级 就用<span>威笑软件</span></div>
        <div class="t2">10000+ 企业正在使用我们的产品降本增效</div>
      </div>
    </div>
    <div class="cashier">
      <div class="text">
        <div class="t1">收银应用</div>
        <div class="t2">支持 iOS，Android，Windows，微信小程序</div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="win" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">收银Windows客户端</div>
          <div class="t2">请访问PC模式网页</div>
        </div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="fpsy" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">Android客户端</div>
          <div class="btn" @click="clickdownload">下载收银 Android 客户端</div>
        </div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="win8" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">收银管家 微信小程序</div>
          <div class="t3">请使用微信扫描二维码</div>
        </div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="fp" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">威笑收银管家APP</div>
          <div class="btn" @click="down">下载收银管家 APP</div>
          <div class="t3">Android</div>
        </div>
      </div>
    </div>
    <!-- <div class="cashier cashier1">
      <div class="text">
        <div class="t1">智慧零售应用</div>
        <div class="t2">支持 iOS，Android，微信小程序</div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="win" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">收银Windows客户端</div>
          <div class="t2">请访问PC模式网页</div>
        </div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="ls" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">零售商城小程序</div>
          <div class="t3">请使用微信扫描二维码</div>
        </div>
      </div>
    </div>
    <div class="cashier">
      <div class="text">
        <div class="t1">订货</div>
        <div class="t2">支持 iOS，Android，微信小程序</div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="fpdh" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">丰派订货小程序</div>
          <div class="t3">请使用微信扫描二维码</div>
        </div>
      </div>
      <div class="app">
        <div class="img-box">
          <img :src="fp" alt="" class="img" />
        </div>
        <div class="txt">
          <div class="t1">订货管理APP</div>
          <div class="btn">开发中即将上线...</div>
          <div class="t3">Android/div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import win from "@/assets/win1.png";
import fpsy from "@/assets/fpsy.png";
import win8 from "@/assets/win8.png";
import fp from "@/assets/fp.png";
import ls from "@/assets/ls.png";
import fpdh from "@/assets/fpdh.png";

export default {
  data() {
    return {
      win,
      fpsy,
      win8,
      fp,
      ls,
      fpdh,
      time: null,
    };
  },
  activated() {
    this.play();
    this.$refs.downloadh5.scrollIntoView();
    this.$refs.video.controls = false;
  },
  methods: {
    down() {
      window.open("https://www.vx8848.com/vxPos/#/download", "_self");
    },
    play() {
      this.$refs.video.play();
      this.time = setInterval(() => {
        this.$refs.video.play();
      }, 0);
    },
    clickdownload() {
      let elink = document.createElement("a");
      elink.download = "Android版本下载";
      elink.style.display = "none";
      elink.href = "https://www.ld8848.cn/vx_pos_android_new/vx_pos_android.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    beforeCreate() {
      clearInterval(this.time);
      this.time = null;
    },
  },
};
</script>
<style lang="less" scoped>
.downloadh5 {
  width: 750px;
  .introduce {
    height: 746px;
    padding: 64px 15px;
    background: linear-gradient(
      180deg,
      #e8f1ff 0%,
      rgba(232, 241, 255, 0) 100%
    );
    .video-box {
      width: 720px;
      height: 478px;
      .video {
        width: 100%;
        height: 100%;
      }
      .video::-webkit-media-controls-enclosure {
        display: none;
      }
    }
    .text {
      margin-top: 24px;
      text-align: center;
      .t1 {
        font-size: 48px;
        font-weight: 700;
        line-height: 64px;
        span {
          color: #336fff;
        }
      }
      .t2 {
        margin-top: 16px;
        font-size: 28px;
        color: #637392;
      }
    }
  }
  .cashier {
    background: #f5f7fa;
    padding: 54px 0;
    .text {
      margin-top: 24px;
      text-align: center;
      margin-bottom: 40px;
      .t1 {
        font-size: 48px;
        font-weight: 500;
        line-height: 64px;
        color: #1f2329;
      }
      .t2 {
        margin-top: 20px;
        font-size: 28px;
        color: #637392;
      }
    }
    .app {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 80px;
      .img-box {
        width: 280px;
        height: 280px;
        background: #ffffff;
        box-shadow: 4px 8px 20px 4px rgba(69, 110, 205, 0.1);
        border-radius: 24px;
        overflow: hidden;
        .img {
          width: 280px;
          height: 280px;
        }
      }
      .txt {
        font-size: 32px;
        line-height: 40px;
        color: #292929;
        font-weight: 500;
        margin-top: 24px;
        text-align: center;
        .t2 {
          margin-top: 16px;
          font-weight: 350px;
          font-size: 24px;
          line-height: 28px;
        }
        .t3 {
          margin-top: 16px;
          font-size: 26px;
          line-height: 34px;
          color: #336fff;
        }
        .btn {
          margin-top: 24px;
          color: #ffffff;
          padding: 24px 40px;
          background: #336fff;
          box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
          border-radius: 16px;
        }
      }
    }
  }
  .cashier1 {
    background: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/downloadH5.vue